import axios from "axios";
import { apiHttp } from "@/api";
import store from "../store";

import { Message, Notification } from "element-ui";

axios.defaults.timeout = 0;
//注释:测试分支合并
// // dev
// let baseURL = "";
// let baseURL1 = 'http://212.64.82.240:8103';//测试
// let baseURL2 = 'http://212.64.82.240:6103/'
// let baseURL3 = 'http://212.64.82.240:6203/';

// // test
let baseURL = "";
// let baseURL1 = "http://192.168.31.93:7802"; //测试
// let baseURL1 = "https://www.cloudisign.com:8000";
let baseURL1 = process.env.VUE_APP_BASE_URL; //测试
// let baseURL1 = "http://121.5.119.236:7802"; //测试
// let baseURL2 = "https://www.cloudisign.com:6100";
let baseURL2 = process.env.VUE_APP_BASE_FILE_URL;
let baseURL3 = "http://212.64.82.240:8102"; //测试
let onlineServerDoc =
  "http://onlinefile.iquatrust.com//we/wordeditorframe.aspx?WOPISrc=http://47.116.118.58:6102/wopi/files/";
let onlineServerXls =
  "http://onlinefile.iquatrust.com/x/_layouts/xlviewerinternal.aspx?edit=1&WOPISrc=http://172.19.111.138:6102/wopi/files/";
// // qas
/* let baseURL="";
let baseURL1 = 'http://118.24.237.234:7801';//测试
let baseURL2 ='http://47.116.118.58:6101/'
let baseURL3 = 'http://118.24.237.234:6201/';
let onlineServerDoc="http://onlinefile.iquatrust.com//we/wordeditorframe.aspx?WOPISrc=http://47.116.118.58:6101/wopi/files/"
let onlineServerXls="http://onlinefile.iquatrust.com/x/_layouts/xlviewerinternal.aspx?edit=1&WOPISrc=http://172.19.111.138:6101/wopi/files/" */
// // prd
/* let baseURL = "";
let baseURL1 = 'https://www.cloudisign.com:7800';//测试
let baseURL2 = 'https://www.cloudisign.com:6100/'
let baseURL3 = 'https://www.cloudisign.com:6200/';
let onlineServerDoc="https://onlinefile.iquatrust.com//we/wordeditorframe.aspx?WOPISrc=http://47.116.118.58:61000/wopi/files/"
let onlineServerXls="https://onlinefile.iquatrust.com/x/_layouts/xlviewerinternal.aspx?edit=1&WOPISrc=http://47.116.118.58:61000/wopi/files/" */
// /* 确定token接受 */
let isgo = true; /*  */

baseURL1 = "http://192.168.31.93:8888";

export { onlineServerDoc };
export { onlineServerXls };

let isShow = true;
let tokenErrorShow = true;

/* post 请求 */
export function post(url, data, errorTip) {
  let str = url.split("/")[1];
  switch (str) {
    case "sys":
    case "ums":
      break;
    default:
      url = "/signtrust" + url;
      break;
  }
  return apiHttp.post(url, data);
  isShow = true;
  tokenErrorShow = true;
  // console.log(url, '---------输出URL')
  // console.log(str)
  if (str == "apiservice") {
    baseURL = baseURL3;
  } else {
    baseURL = baseURL1;
  }
  // if (str == "ctmsserver" || str == "userserver") {

  // } else if (str == "ctmsserver") {
  //     baseURL = baseURL3;
  // } else
  if (str == "filemanage" || str == "wopi") {
    baseURL = baseURL2;
  }
  // else {
  //     baseURL = baseURL1;
  // }
  // if (!data) {
  //     data = {};
  // }
  if (!data) data = {};
  // // console.log(axios.defaults.baseURL)
  data.token = localStorage.token;
  // data.userId = localStorage.userId;
  data.usrId = localStorage.userId;
  data.clientplatformId = 0;
  data.usrPhone = localStorage.userPhone;
  // if (data.operateUserId == undefined || data.operateUserId == null || data.operateUserId == "") {
  //     data.operateUserId = store.getters.userId;
  // }
  // data.clientplatformId = 1;

  return new Promise((resolve, reject) => {
    if (isgo) {
      isgo = true;
      axios
        .post(baseURL + url, JSON.stringify(data), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(
          (response) => {
            if (response.status == 200) {
              const data = response.data;
              if (data && data.code && data.code === 200 && data.success) {
                return resolve(data);
              }
              if (data && data.msg) {
                if (isShow) {
                  Message.error(data.msg);
                  isShow = false;
                }
              }

              if (data && data.code) {
                if (["100000", "401"].includes(`${data.code}`)) {
                  // setTimeout(() => {
                  //   localStorage.clear();
                  //   window.location.href = "/sso-web/login";
                  // }, 1000);
                }
              }

              if (
                response.data.success ||
                response.data.isSuccess ||
                response.data.result
              ) {
                resolve(response.data);
              } else {
                if (errorTip !== false) {
                  if (isShow) {
                    Notification.warning({
                      title: "错误",
                      message: response.data.errorMessage || "请求失败",
                    });
                    isShow = false;
                  }
                }
                reject(response.data);
              }
            } else {
              reject(response.data);
              if (isShow) {
                Notification.error({
                  title: response.status,
                  message: "请求异常",
                });
                isShow = false;
              }
            }
            isgo = true;
          },
          (err) => {
            // console.log(err.response);
            // console.log(err.result);
            Notification.error({
              title: err.response ? err.response.status : err.message,
              message: "网络异常",
            });
            reject(err);
            isgo = true;
          }
        );
    }
  });
}

/* 不带token 的post 请求 */
export function post_notoken(url, data) {
  // console.log(url, '---------输出URL')
  let str = url.split("/")[1];
  // // console.log(str)
  // if (str == "ctmsserver" || str == "userserver") {
  baseURL = baseURL1;
  if (str == "filemanage" || str == "wopi") {
    baseURL = baseURL2;
  }
  // } else if (str == "ctmsserver") {
  //     baseURL = baseURL3;
  // } else if (str == "filemanage" || str == "wopi") {
  //     baseURL = baseURL2;
  // }

  return new Promise((resolve, reject) => {
    axios
      .post(baseURL + url, JSON.stringify(data), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(
        (response) => {
          resolve(response.data);
          // console.log("sent", data, url)
          // console.log("res:", response.data)
        },
        (err) => {
          Notification.error({
            title: "错误",
            message: "网络异常",
          });
          reject(err);
        }
      );
  });
}

/* 文件上传 */
export function post_file(url, data) {
  // console.log(url, '---------输出URL')
  let str = url.split("/")[1];
  // console.log(str)
  // if (str == "quatrust" || str == "apiservice") {
  baseURL = baseURL2;
  // } else if (str == "centermanage") {
  //     baseURL = baseURL3;
  // } else if (str == "filemanage" || str == "wopi") {
  //     baseURL = baseURL2;
  // }

  return new Promise((resolve, reject) => {
    if (isgo) {
      isgo = true;
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        /* ,
                                       onUploadProgress: (progressEvent) => {
                                           // 使用本地 progress 事件
                                           if (progressEvent.lengthComputable) {
                                               let num = Math.round((progressEvent.loaded / progressEvent.total) * 100)
                                               this.process = num // 使用某种 UI 进度条组件会用到的百分比
                                               console.log("this.process",num,progressEvent.loaded,progressEvent.total)
                                           }
                                       } */
      };
      axios.post(baseURL + url, data, config).then(
        (response) => {
          resolve(response.data);
          // console.log("sent", data, url)
          // console.log("res:", response.data)
          if (response.data.token) {
            localStorage.setItem("token", response.data.token);
          } else {
            /* localStorage.removeItem("token");
                                                localStorage.removeItem('islogin');
                                                localStorage.removeItem("userId");
                                                localStorage.removeItem("coId") */
          }
          isgo = true;
        },
        (err) => {
          reject(err);
          isgo = true;
        }
      );
    }
  });
}

export function post_fileUrl(url, data) {
  let str = url.split("/")[1];
  return new Promise((resolve, reject) => {
    axios
      .post(baseURL2 + url, JSON.stringify(data), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(
        (response) => {
          resolve(response.data);
          if (response.data.token) {
            localStorage.setItem("token", response.data.token);
          } else {
            // location.href = "/login.html"
          }
        },
        (err) => {
          reject(err);
        }
      );
  });
}
